import { Injectable } from '@angular/core';
import { ApplicationHttpClient } from 'app/application-http-client';
import { Observable } from 'rxjs';

import {
  ServerInfo,
  TradeInVehicle,
  VehicleDecodedVinDTO,
  VehicleMake,
  VehicleModel,
  VehicleTrim,
  VehicleYear,
} from '../vehicle-info/vehicle-info';

// import 'rxjs/add/operator/catch';
// import 'rxjs/add/operator/map';

@Injectable()
export class VehicleInfoService {
  private apiUrl = '/TradeIn/VehicleDetails';
  private vinUrl = '/TradeIn/DecodeVIN';
  private tradeUrl = '/TradeIn/TradeIn';

  public getServerInfo(dealerId: number): Observable<ServerInfo> {
    const params = ApplicationHttpClient.toHttpParams({
      dealerId: dealerId
    });

    return this.http.get(this.tradeUrl + '/GetServerAsync', { params: params, errorNotification: true });
  }

  public getVehicleYears(dealerId: number, serverName: string, dbName: string): Observable<VehicleYear[]> {
    const params = ApplicationHttpClient.toHttpParams({
      dealerId: dealerId,
      serverName: serverName,
      dbName: dbName
    });

    return this.http.get(this.apiUrl + '/GetYears', { params: params, errorNotification: true });
  }

  public getVehicleMakes(dealerId: number, yearCode, serverName: string, dbName: string): Observable<VehicleMake[]> {
    const params = ApplicationHttpClient.toHttpParams({
      dealerId: dealerId,
      serverName: serverName,
      dbName: dbName,
      yearCode: yearCode
    });

    return this.http.get(this.apiUrl + '/GetMakes', { params: params, errorNotification: true });
  }

  public getVehicleModels(
    dealerId: number,
    yearCode: string,
    make: string,
    serverName: string,
    dbName: string
  ): Observable<VehicleModel[]> {
    const params = ApplicationHttpClient.toHttpParams({
      dealerId: dealerId,
      serverName: serverName,
      dbName: dbName,
      yearCode: yearCode,
      make: make
    });

    return this.http.get(this.apiUrl + '/GetModels', { params: params, errorNotification: true });
  }

  public getVehicleTrims(
    dealerId: number,
    yearCode: string,
    make: string,
    model: string,
    serverName: string,
    dbName: string
  ): Observable<VehicleTrim[]> {
    const params = ApplicationHttpClient.toHttpParams({
      dealerId: dealerId,
      serverName: serverName,
      dbName: dbName,
      yearCode: yearCode,
      make: make,
      model: model
    });

    return this.http.get(this.apiUrl + '/GetTrims', { params: params, errorNotification: true });
  }

  public getVehicleDecodedVin(dealerId: number, vin: string, serverName: string, dbName: string): Observable<VehicleDecodedVinDTO> {
    const params = ApplicationHttpClient.toHttpParams({
      dealerId: dealerId,
      serverName: serverName,
      dbName: dbName,
      vin: vin
    });

    return this.http.get(this.vinUrl, { params: params, errorNotification: true });
  }

  public submitVehicleQuote(car: TradeInVehicle): void {
    // debugger;
    this.http.post(this.tradeUrl + '/quote', car).subscribe(res => {
      console.debug('quote returned: ' + res);
    });
  }

  constructor(private http: ApplicationHttpClient) { }
}
